import { IUser, IPasswordData, IUserWithToken } from "@/../../server/src/user/IUser";

export class user_api {
    
    public static login:string ="/api/user/login"
    public static get_users_by_filter:string ="/api/user/get_users_by_filter"
    
}

export interface IUserSvc {
    
    login(pd: IPasswordData): Promise<IUserWithToken | undefined>
    get_users_by_filter(filter:string): Promise<IUser[]>
    
}